<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Faktury'" [name]="'Lista do przelewu'"></app-breadcrumb>
<div class="invoice-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

      <app-month-picker
        class="invoice-list-filter"
        label="Miesiąc rozliczeniowy" [required]="false"
        name="billingMonth" [(ngModel)]="initialFilters.billingMonth"
      ></app-month-picker>
      <mat-form-field class="invoice-list-filter">
        <mat-label>Numer</mat-label>
        <input matInput placeholder="Numer" name="contains$number" [(ngModel)]="initialFilters.contains$number">
      </mat-form-field>

      <app-dict-ofwcas
        [multiple]="false" label="OFWCA"
        class="invoice-list-filter"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-partners
        [multiple]="false" label="Partner"
        class="invoice-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>
      <mat-form-field class="invoice-list-filter">
        <mat-label>Kwota od</mat-label>
        <input matInput placeholder="Kwota od" name="gte$net" [(ngModel)]="initialFilters.gte$net">
      </mat-form-field>

      <mat-form-field class="invoice-list-filter">
        <mat-label>Kwota do</mat-label>
        <input matInput placeholder="Kwota do" name="lte$net" [(ngModel)]="initialFilters.lte$net">
      </mat-form-field>

      <app-dict-regionals
        [multiple]="false" label="Regionalny (majątek)"
        class="invoice-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>

      <app-dict
        [multiple]="false" label="Status"
        class="invoice-list-filter"
        dictType="invoice_status"
        [(ngModel)]="initialFilters.status" name="status"
      ></app-dict>

      <mat-form-field appearance="standard" class="invoice-list-filter">
        <mat-label>Strona umowy</mat-label>
        <mat-select
          [(ngModel)]="initialFilters.owner" name="owner"
          [multiple]="false"
        >
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="'ofwca'">OFWCA</mat-option>
          <mat-option [value]="'partner'">Partner</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="invoice-list-filter">
        <mat-label>Samofakturowanie</mat-label>
        <mat-select [(ngModel)]="initialFilters.selfBilling" name="selfBilling">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="invoice-list-filter">
        <mat-label>Automatyczne rozliczanie</mat-label>
        <mat-select [(ngModel)]="initialFilters.automaticSettlement" name="automaticSettlement">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="invoice-list-filter">
        <mat-label>Faktura wygenerowana</mat-label>
        <mat-select [(ngModel)]="initialFilters.generatedManually" name="generatedManually">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>


      <app-dict
        [multiple]="false" label="Rodzaj umowy"
        class="invoice-list-filter"
        dictType="contract_type"
        [(ngModel)]="initialFilters.contractType" name="contractType"
      ></app-dict>

    </form>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="generatePayment()" [disabled]="!(userPermissions | async).settlement.read_report"
            mat-stroked-button>
      <mat-icon>download</mat-icon>
      <span> Generuj plik do banku </span></button>
    <!--    <button (click)="importPayment()" [disabled]="!(userPermissions | async).settlement.read_report"  mat-stroked-button  ><mat-icon>publish</mat-icon> <span> Importuj plik z banku </span></button>-->
    <span fxFlex></span>
    <div>
      <app-detail style="position: relative; top: -1px" header="Liczba faktur do zrealizowania"
                  [value]="numberOfInvoicesToBeProcessedFun().toString()"></app-detail>
    </div>
    <div>
      <app-detail style="position: relative; top: -1px" header="Liczba faktur wstrzymanych"
                  [value]="numberOfInvoicesOnHoldFun().toString()"></app-detail>
    </div>
    <span fxFlex></span>

    <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()"
            [disabled]="!(userPermissions | async).settlement.read_report" mat-raised-button class="report-button">
      <mat-icon>download</mat-icon>
      <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary">
      <mat-icon>search</mat-icon>
      <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">
    <table mat-table [dataSource]="items" matSort (matSortChange)="sortChanged($event)">

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef> Firma</th>
        <td mat-cell *matCellDef="let element">
          {{ element.contract.company.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="number"> Numer</th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/faktury/szczegoly', element?.id]">
            {{ element.number }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="party">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="party"> Partner/OFWCA</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.partner">
            <a class="default-link"
               [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{ element.partner?.shortName }}</a>
            <span *ngIf="element.partner.fullName !== element.sellerCompanyName"> ({{ element.sellerCompanyName }}
              ) </span>
          </ng-container>

          <ng-container *ngIf="element.ofwca">
            <a class="default-link"
               [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{ element.ofwca.fullName }}</a>
            <span *ngIf="element.ofwca.fullName !== element.sellerCompanyName"> ({{ element.sellerCompanyName }}
              ) </span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="contractOwner">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="contractOwner"> Strona umowy</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.partner">
            Partner
          </ng-container>

          <ng-container *ngIf="element.ofwca">
            OFWCA
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="billingMonth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="billingMonth"> Miesiąc rozliczeniowy</th>
        <td mat-cell *matCellDef="let element">
          <div fxLayout="row" fxLayoutGap="5" fxLayoutAlign="start center">

            <a class="default-link" [routerLink]="['/faktury/szczegoly', element?.id]">
              {{ element.billingMonth }}
            </a>
            <mat-chip-list *ngIf="element.generatedManually">
              <mat-chip class="statusChange-button-container" color="primary" matTooltip="Faktura wygenerowana">G</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.selfBilling">
              <mat-chip class="statusChange-button-container" color="primary" matTooltip="Samofakturowanie">S</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.automaticSettlement">
              <mat-chip class="statusChange-button-container chip-automatic-settlement" selected
                        matTooltip="Automatyczne rozliczanie">A
              </mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="!element.sellerAccountNumber">
              <mat-chip class="statusChange-button-container" color="warn" selected
                        matTooltip="Brak nr rachunku bankowego">B
              </mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.invoiceDocumentTypeCharge">
              <mat-chip class="statusChange-button-container chip-yellow" selected matTooltip="Nota obciążeniowa">O
              </mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.invoiceDocumentTypeCredit">
              <mat-chip class="statusChange-button-container chip-additional-settlement" selected
                        matTooltip="Nota uznaniowa">U
              </mat-chip>
            </mat-chip-list>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="status"> Status</th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
            {{ element.status.name }}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="net">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="net"> Kwota faktury</th>
        <td mat-cell *matCellDef="let element">
          {{ element.net | number:'1.2-2' }} zł
        </td>
      </ng-container>
      <ng-container matColumnDef="payoutNet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="payoutNet"> Kwota do wypłaty</th>
        <td mat-cell *matCellDef="let element">
          {{ element.payoutNet | number:'1.2-2' }} zł
        </td>
      </ng-container>

      <!--      <ng-container matColumnDef="assetsRegional">-->
      <!--        <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>-->
      <!--        <td mat-cell *matCellDef="let element">-->
      <!--          <ng-container *ngIf="element.partner">-->
      <!--            {{element.partner?.assetsRegional?.fullName}}-->
      <!--          </ng-container>-->

      <!--          <ng-container *ngIf="element.ofwca">-->
      <!--            {{element.ofwca?.assetsRegional?.fullName}}-->
      <!--          </ng-container>-->
      <!--        </td>-->
      <!--      </ng-container>-->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
